import { render, staticRenderFns } from "./SolicitudApitab.vue?vue&type=template&id=84d43d88"
import script from "./SolicitudApitab.vue?vue&type=script&lang=js"
export * from "./SolicitudApitab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports